import { useTranslation } from 'react-i18next'

import { InputWithLabel, Text, UploadImage } from '@reveni-io/reveni-ui'

import { acceptedImageTypes } from '@/configuration/pages/ConfigurationPage/ReturnProtectionConfiguration/ReturnProtectionAppearanceConfiguration/constants'
import ResetToDefaultButton from '@/configuration/pages/ConfigurationPage/ReturnProtectionConfiguration/ReturnProtectionAppearanceConfiguration/ResetToDefaultButton/ResetToDefaultButton'

import { productImageMaxSizeKb, productTitleMaxLength } from './constants'
import * as Styles from './styles'

const DigitalProductForm = ({
  title,
  onChangeTitle,
  onChangeImage,
  uploaderKey,
  onResetToDefault,
  resetting,
  resetDisabled,
}) => {
  const { t } = useTranslation()

  const handleChangeTitle = event => onChangeTitle(event.target.value)

  return (
    <Styles.Container>
      <UploadImage
        key={uploaderKey}
        label={t('Imagen del producto')}
        buttonText={t('Subir archivo')}
        recommendation={t('JPG, PNG - se recomienda cuadrada. Déjalo vacío para usar el placeholder.')}
        onChange={onChangeImage}
        accept={acceptedImageTypes}
        maxSize={productImageMaxSizeKb}
        withoutPreview
      />
      <Styles.Field>
        <Text type="bodyMMedium">{t('Título')}</Text>
        <InputWithLabel
          label={t('Texto de la etiqueta')}
          value={title}
          onChange={handleChangeTitle}
          maxLength={productTitleMaxLength}
          helperText={t('El SKU no es editable.')}
          fullWidth
        />
      </Styles.Field>
      <ResetToDefaultButton onClick={onResetToDefault} loading={resetting} disabled={resetDisabled} />
    </Styles.Container>
  )
}

export default DigitalProductForm
